import addNote from './add-note.action';

export default addNote;
